import {ButtonItem} from "@atlaskit/menu";
import type {ComponentProps} from "react";

export type AnankeMenuButtonItemProps = ComponentProps<typeof ButtonItem> & {
    dataAnalyticsEvent: string | null;
    dataAnalyticsProps: string | null;
};

export function AnankeMenuButtonItem({
    dataAnalyticsEvent = null,
    dataAnalyticsProps = null,
    ...props
}: Omit<AnankeMenuButtonItemProps, "dataAnalyticsEvent" | "dataAnalyticsProps"> & {
    dataAnalyticsEvent?: string | null;
    dataAnalyticsProps?: string | null;
}) {
    const analyticsHtmlAttributes: {
        "data-analytics-event"?: string;
        "data-analytics-props"?: string;
    } = {};
    if (dataAnalyticsEvent !== null) {
        analyticsHtmlAttributes["data-analytics-event"] = dataAnalyticsEvent;
    }
    if (dataAnalyticsProps !== null) {
        analyticsHtmlAttributes["data-analytics-props"] = dataAnalyticsProps;
    }
    return (
        <ButtonItem
            {...props}
            {...analyticsHtmlAttributes}
        />
    );
}
